import { Buffer } from 'buffer';

// @ts-ignore
window.global = window;
window.Buffer = Buffer;
// @ts-ignore
window.process = {
  env: { NODE_ENV: 'production', PUBLIC_URL: '' } as any,
  version: '',
  // @ts-ignore
  nextTick: (fn: Function, ...args: any[]) => setTimeout(() => fn(...args), 0)
};